/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatus } from './entityStatus';

export interface Areas { 
    _id?: string;
    areaCode?: number;
    name?: string;
    entityStatus?: EntityStatus;
    countryId?: string;
    dateCreated?: Date;
    deleted?: boolean;
    id?: number;
}